import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectCustomers = (state: RootState) =>
  sortBy(state.customers.customers, 'name');

export const selectCustomerErrors = (state: RootState) =>
  state.customers.errors;
